import { createContext } from 'react';

export const DragAndDropListHandleContext = createContext<(element: Element | null) => void>(() => undefined);
